import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import buildInfo from "../buildInfo.json";

export const FRONTEND_BUILD_ID = buildInfo.build_id;

// Admin-only build identity: proves which frontend bundle and which backend replica/version are actually being served.
export const BuildIdentity = () => {
  const [be, setBe] = useState(null);
  const [samples, setSamples] = useState([]);
  const probe = async () => {
    const seen = [];
    for (let i = 0; i < 5; i++) { try { const r = await api.get("/build-info", { params: { _: Date.now() + i } }); seen.push(r.data); } catch (e) { seen.push({ error: String(e?.message || e) }); } }
    setBe(seen[0]); setSamples(seen);
  };
  useEffect(() => { probe(); }, []);
  const replicas = [...new Set(samples.map((x) => x.replica).filter(Boolean))];
  const versions = [...new Set(samples.map((x) => x.backend_source_version).filter(Boolean))];
  const mixed = versions.length > 1;
  return (
    <div data-testid="build-identity" className="rounded-lg border border-border/60 p-3 text-[12px] font-mono space-y-1">
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Build identity (diagnostics)</div>
      <div>Frontend build: <span data-testid="frontend-build-id" className="text-green-300">{FRONTEND_BUILD_ID}</span> <span className="opacity-60">(src {buildInfo.source_version}, built {buildInfo.built_at})</span></div>
      <div>Backend build: <span data-testid="backend-build-id" className={mixed ? "text-red-300" : "text-green-300"}>{be?.backend_build_id || "…"}</span> <span className="opacity-60">src {be?.backend_source_version} · booted {be?.build_timestamp} · env {be?.environment}</span></div>
      <div>Backend replica: <span data-testid="backend-replica">{be?.replica || "…"}</span> <span className="opacity-60">· {samples.length} probes → {replicas.length} replica(s) {replicas.join(", ")} · {versions.length} version(s)</span></div>
      <div className={be && buildInfo.source_version !== be.backend_source_version ? "text-amber-300" : "text-green-400"} data-testid="build-match">
        {be ? (buildInfo.source_version === be.backend_source_version ? "✓ frontend and backend built from the same source" : `⚠ frontend src ${buildInfo.source_version} ≠ backend src ${be.backend_source_version} — cached bundle or old replica`) : ""}
        {mixed ? " · ⚠ MIXED BACKEND VERSIONS across replicas" : ""}
      </div>
      <button onClick={probe} className="underline text-[11px]" data-testid="build-identity-reprobe">re-probe replicas</button>
    </div>
  );
};
